import styled from 'styled-components';

// CARD SERVICO DOCUMENTO

export const CardServico = styled.div`
  width: 28%;
  padding-bottom: 130px;
  background-color: var(--background-second-sefaz);
  border-radius: 10px;
  box-shadow: 0 2px 6px rgb(0 0 0 / 16%);
  padding: 20px;
  padding-bottom: 30px;
  margin: 20px;
  transition: all 0.2s ease-in-out;

  background: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.18);

  &:hover {
    background: #ffffff;
    transform: translateY(-3px);
    box-shadow: 0 4px 17px rgba(0, 0, 0, 0.1);
  }
`;

export const CardServicoIcone = styled.div`
  width: 30%;
  height: 70px;
  margin: auto;
  border-radius: 100%;
  display: flex;
  span {
    margin: auto;
  }
  svg {
    font-size: 30pt;
  }
`;

export const CardServicoLabel = styled.p`
  margin: 0px;
  font-size: 14pt;
  font-weight: 500;
  text-align: center;
`;

export const CardServicoDescricao = styled.p`
  margin: 0px;
  font-size: 10pt;
  text-align: center;
  word-break: break-word;
`;

// CARD ENDERECO

export const CardInputs = styled.div`
  width: 28%;
  padding-bottom: 130px;
  background-color: var(--background-second-sefaz);
  margin: 20px;
  margin-top: 50px;
  border-radius: 10px;
  box-shadow: 0 2px 6px rgb(0 0 0 / 16%);
  padding: 40px;
  padding-bottom: 30px;
  transition: all 0.2s ease-in-out;

  background: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.18);

  &:hover {
    background: #ffffff;
    transform: translateY(-3px);
    box-shadow: 0 4px 17px rgba(0, 0, 0, 0.1);
  }
`;

export const CardInputsContainerLabel = styled.div`
  display: flex;
  margin-bottom: 5px;
`;

export const CardInputsTitulo = styled.p`
  margin: 0px;
  font-weight: 500;
  font-size: 20pt;
  text-align: center;
  margin: 5px;
  margin-bottom: 30px;
`;

export const CardInputsLabel = styled.p`
  margin: 0px;
  font-weight: 500;
`;

export const CardInputsDescricao = styled.p`
  margin: 2px;
  font-size: 10pt;
  margin-left: 3px;
  word-break: break-word;
`;
